/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import './style.scoped.scss';
import { Button, Dropdown, Modal } from 'react-bootstrap';
import { IoMdClose } from 'react-icons/io';
import { connect } from 'react-redux';
import {
  GetPaddlePrices,
  UpdateUserUsage,
} from '../../../store/Paddle/paddleActions';
import { usePaddle } from '../../../hooks/usePaddle';
import { USER, notification } from '../../../assets/constants/strings';
import { CreateAdditionalQueries } from '../../../store/Client/clientActions';

const mapStateToProps = (state) => ({
  prices: state.paddle.prices,
  user: state.user.user,
});

const mapDispatchToProps = {
  GetPaddlePrices,
  UpdateUserUsage,
  CreateAdditionalQueries,
};

const CreditsModal = ({
  show,
  handleClose,
  prices,
  GetPaddlePrices,
  CreateAdditionalQueries,
}) => {
  const [dropdownItems, setDropdownItems] = useState([]);
  const [selected, setSelected] = useState();

  const eventCallbackFunction = async (data) => {
    if (data.name === 'checkout.completed') {
      // console.log(data);

      // update user queries for the current billing cycle
      const res = await CreateAdditionalQueries(
        USER.USAGE.ADDITIONALQUERIES,
        Number(selected.name.split(' ')[0])
      );
      if (res && res.success) {
        closeCheckout();
        handleClose();
        notification('success', 'Queries added to your account.');
      } else {
        notification(
          'error',
          'Could not finalise operation. Please try again later.'
        );
      }
    }
  };

  const { openCheckout, closeCheckout } = usePaddle(
    eventCallbackFunction,
    false
  );

  useEffect(() => {
    if (!prices) GetPaddlePrices();
    else {
      setDropdownItems(
        prices
          .filter((item) => item.billing_cycle === null)
          .map((item) => ({
            ...item,
            name: `${item.name} - $${item.unit_price.amount / 100}`,
          }))
          .sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { numeric: true })
          )
      );
    }
  }, [prices]);

  useEffect(() => {
    if (dropdownItems && dropdownItems.length > 0)
      setSelected(dropdownItems[0]);
  }, [dropdownItems]);

  const handleValue = (value) => {
    setSelected(value);
  };

  const handlePayment = () => {
    const itemsList = [
      {
        priceId: selected.id,
        quantity: 1,
      },
    ];
    openCheckout(itemsList);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Addtional Queries</Modal.Title>
        <IoMdClose onClick={handleClose} style={{ cursor: 'pointer' }} />
      </Modal.Header>
      <Modal.Body>
        <p>
          Select the number of additional queries that you want to purchase from
          the dropdown below.
        </p>
        <p>Your default payment method will be charged automatically.</p>
        <p>These AI queries are valid only for the current billing cycle.</p>

        <Dropdown drop='down'>
          <Dropdown.Toggle variant='success' className='dropdownBtn'>
            {selected && selected.name}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {dropdownItems &&
              dropdownItems.map((item, index) => (
                <Dropdown.Item key={index} onClick={() => handleValue(item)}>
                  {item.name}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Modal.Body>
      <Modal.Footer>
        <Button className='updateSubsBtn w-100' onClick={handlePayment}>
          Complete Purchase
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditsModal);
